"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactNative = require("react-native");
var _default = _reactNative.TurboModuleRegistry.get('RNPerformanceManager');
exports.default = _default;
//# sourceMappingURL=NativeRNPerformanceManager.js.map